import * as React from "react";
import {createElement as h} from "react";

import {cs}                     from "@Common/react/chain-services";
import {formatMoneyBackOptions} from "@Common/ui-components/language/format-money";
import {plural}                 from "@Common/ui-components/language/plural";
import {parseUrlQuery}          from "@Common/utils/parse-url-query";
import {consumeContext}         from "@Common/react/context";

import {ObserveDom}      from "../../../../../common/components/observe-dom";
import {filteredOptions} from "../../../../../common/filtered-options";

import {ImageSelector}       from "./image-selector/image-selector";
import {SelectTemplate}      from "./select-template/select-template";
import {ChangeTemplateModal} from "../../change-tempalte-modal/change-template-modal";

export const BackTemplateSelector = ({next, templateBacks, isFromApproval, item, selected}) => cs(
    consumeContext("apis"),
    consumeContext("routerHistory"),
    ["query", (_, next) => next(parseUrlQuery(location.search))],
    ["changeTemplateModal", ({}, next) => ChangeTemplateModal({next})],
    ["selectTemplate", ({}, next) => SelectTemplate({
        title: "Available " + plural("Back", templateBacks.length),
        templateBacks,
        selected,
        next,
    })],
    ({apis, routerHistory, query, selectTemplate, changeTemplateModal}) => next({
        render: () => cs(
            ["size", (_, next) => h(ObserveDom, {next})],
            ({size}) => (
                <div className="back-template-selector-bf1">
                    {ImageSelector({
                        size,
                        images: templateBacks?.map((back) => ({
                            id: back.id,
                            src: back.image,
                            selected: back.id === selected.value,
                            onSelect: () => new Promise<void>((resolve, reject) => {
                                let confirm = false
                                isFromApproval && item.sku.back !== back.id ? (
                                    changeTemplateModal.show({
                                        confirm: async () => {
                                            routerHistory.replace(`/product-options/order/${item.itemId}`)
                                            selected.onChange(back.id)
                                            await apis.next.approval.denyCcCart(query.id_cart)
                                            confirm = true
                                            return {confirm: true};
                                        },
                                        onClose: () => confirm ? resolve() : reject()
                                    }) 
                                ) : (
                                    selected.onChange(back.id)
                                )
                            }),
                            details: (
                                <div className="details-9wr">
                                    <div className="title">
                                        {back.name}
                                    </div>

                                    {back.option && <div className="sub">
                                        {formatMoneyBackOptions(back.option.reduce((cnt, option) => {return cnt + option.unitprice;}, 0))}
                                        {" - "}{filteredOptions(back.option)}
                                    </div>}
                                </div>
                            ),
                        })),
                        onMore    : () => new Promise<void>((resolve, reject) => {
                            let confirm = false
                            isFromApproval ? (
                                changeTemplateModal.show({
                                    confirm: async () => {
                                        routerHistory.replace(`/product-options/order/${item.itemId}`)
                                        await apis.next.approval.denyCcCart(query.id_cart)
                                        selectTemplate.list()
                                        confirm = true
                                        return {confirm: true};
                                    },
                                    onClose: () => confirm ? resolve() : reject()
                                }) 
                            ) : (
                                selectTemplate.list()
                            )
                        }),
                        onEnlarge: () => selectTemplate.single(selected.value),
                        getLastSelected: selectTemplate.getLastSelected,
                    })}
                </div>
            ),
        ),
    }),
);